import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import moment from "moment-mini";
import { TODAY_DATE } from "Common/Constants";

const EligibilityErrorList = forwardRef(({ eligibilityData }, ref) => {
  const contentToPrint = useRef(null);
  const { userinfo, practiceDetails } = useSelector((state) => state.userAuth);
  const errors = eligibilityData.patientEligibilityErrors ?? [];

  useImperativeHandle(ref, () => {
    return {
      handlePrintPKG,
      printContent: () => contentToPrint.current,
    };
  });
  const handlePrintPKG = useReactToPrint({
    documentTitle: "Eligibility Log",
    removeAfterPrint: false,
  });
  if (errors.length > 0) {
    return (
      <div className="mb-4">
        <div
          id="printErrorView"
          ref={contentToPrint}
          className="scroll-container"
        >
          <div className="bg-white">
            <p className="px-0 py-2 text-base font-semibold text-slate-800">
              Eligibility Errors
            </p>
            <ul className="space-y-2">
              {errors.map((error, index) => (
                <li key={error.id ?? index}>
                  <span className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-red-50 text-red-800 text-sm ">
                    <span
                      className="w-2 h-2 rounded-full bg-red-400 flex-shrink-0"
                      aria-hidden
                    />
                    {error.message}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="justify-between hidden mx-4 mt-4 font-semibold print:flex text-slate-600">
            <p>Downloaded By : {userinfo.userName}</p>
            <p>Date : {moment(TODAY_DATE).format("MM/DD/YYYY")}</p>
            <p>Practice : {practiceDetails.name}</p>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
});

export default EligibilityErrorList;
